import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import { API_SCHEME, API_HOST, API_PATH } from 'utils/env';

export const baseURL = 'nominas/retenciones-de-pagos-empleados';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Retenciones de pagos
 * @return {Promise<object[]>}
 */
export const getRetencionesDePagos = async () => {
  try {
    const response = await API.get(baseURL);
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

/**
 * @param {*} id
 * @returns {Promise<object>}
 */
export const getRetencionDePago = async (id) => {
  try {
    const response = await API.get(`${baseURL}/${id}`);
    return response.data;
  } catch (error) {
    onError(error);
    return null;
  }
};

/**
 * @param {object} values
 * @returns {Promise<object>}
 */
export const postRetencionDePago = async (values) => {
  try {
    const response = await API.post(baseURL, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente.');
    return response.data;
  } catch (error) {
    onError(error);
    return null;
  }
};

/**
 * @param {*} id
 * @param {object} values
 * @returns {Promise<object>}
 */
export const patchRetencionDePago = async (id, values) => {
  try {
    const response = await API.patch(`${baseURL}/${id}`, values);
    onSuccess(response, 'Editado correctamente.');
    return response.data;
  } catch (error) {
    onError(error);
    return null;
  }
};

/**
 * @param {*} id
 * @returns {Promise<object>}
 */
export const deleteRetencionDePago = async (id) => {
  try {
    const response = await API.delete(`${baseURL}/${id}`);
    onSuccess(response, 'Eliminado correctamente.');
    return true;
  } catch (error) {
    onError(error);
    return null;
  }
};

/**
 * PUT Retenciones de Pago Estatus
 * @param {object} values@returns {Promise<{}>}
 */
export const putRetencionesDePagos = async (values) => {
  try {
    const response = await API.put('nominas/actualizar-estado-retencion-de-pago', values);
    onSuccess(response, 'Retenido correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Retenciones de Pago Estatus
 * @param {object} values@returns {Promise<{}>}
 */
export const putLiberacionesDePagos = async (values) => {
  try {
    const response = await API.put('nominas/actualizar-estado-retencion-de-pago', values);
    onSuccess(response, 'Liberado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Retenciones de Pago Estatus
 * @param {object} values@returns {Promise<{}>}
 */
export const putCancelacionesDePagos = async (values) => {
  try {
    const response = await API.put('nominas/actualizar-estado-retencion-de-pago', values);
    onSuccess(response, 'Cancelado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT DELETE Retenciones de Pago Estatus
 * @param {object} values@returns {Promise<{}>}
 */
export const deleteRetencionesDePagos = async (values) => {
  try {
    const response = await API.put('nominas/eliminar-retencion-de-pago', values);
    onSuccess(response, 'Eliminados correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Retencion de Pago Plantilla
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getRetencionDePagoPlantilla = async () => {
  try {
    const response = await API.get(`${API_SCHEME}://${API_HOST}${API_PATH}nominas/retencion-de-pago-obtener-plantilla-excel`, {
      headers: {
        'Content-Type': 'application/ms-excel',
      },
      responseType: 'arraybuffer',
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
